import { IEntityManagerConfiguration } from '@dch/entity-manager';
import { LocalForageStrategy } from '@dch/entity-manager/lib/storage/strategies/local-forage.strategy';

const MyBillConfig: Partial<IEntityManagerConfiguration> = {
  application: {
    applicationName: 'myBill',
    applicationVersion: 'v1',
    versionStorageStrategyId: LocalForageStrategy.ID,
    clearStorageIfVersionIsMissing: false,
  },
};

export { MyBillConfig };
